import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import { FlagBRIcon } from './icons/FlagBRIcon';
import { FlagUSIcon } from './icons/FlagUSIcon';

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, t } = useTranslation();

  const handleLanguageChange = (lang: 'pt' | 'en') => {
    if (lang !== language) {
      setLanguage(lang);
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => handleLanguageChange('pt')}
        className={`p-1 rounded-full transition-all duration-200 ${language === 'pt' ? 'ring-2 ring-brand-accent ring-offset-2 ring-offset-brand-secondary' : 'opacity-60 hover:opacity-100'}`}
        aria-label={t('languageSwitcher.aria.pt')}
        title={t('languageSwitcher.aria.pt')}
      >
        <FlagBRIcon className="w-6 h-auto rounded-full" />
      </button>
      <button
        onClick={() => handleLanguageChange('en')}
        className={`p-1 rounded-full transition-all duration-200 ${language === 'en' ? 'ring-2 ring-brand-accent ring-offset-2 ring-offset-brand-secondary' : 'opacity-60 hover:opacity-100'}`}
        aria-label={t('languageSwitcher.aria.en')}
        title={t('languageSwitcher.aria.en')}
      >
        <FlagUSIcon className="w-6 h-auto rounded-full" />
      </button>
    </div>
  );
};
